// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__340ey","placeholdersHeader":"styles_placeholdersHeader__25P6_","editorStyle":"styles_editorStyle__2Q0XQ","placeholdersBox":"styles_placeholdersBox__34ecY"};